import { render, staticRenderFns } from "./depositguide.vue?vue&type=template&id=06b9deea&scoped=true&"
import script from "./depositguide.vue?vue&type=script&lang=js&"
export * from "./depositguide.vue?vue&type=script&lang=js&"
import style0 from "./depositguide.vue?vue&type=style&index=0&id=06b9deea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9deea",
  null
  
)

export default component.exports